import { AspectRatio } from './video';
import { NinjaProviderModel } from '../ninja-job';

export const aspectRatioToFormatMapping = {
  [AspectRatio.OneByOne]: 'square_hd',
  [AspectRatio.NineBySixteen]: 'portrait_16_9',
  [AspectRatio.SixteenByNine]: 'landscape_16_9',
};

interface ModelAspectRatioMapping {
  [model: string]: {
    [ratio in AspectRatio]?: {
      width: number;
      height: number;
      ratioParam: string; // The string you send to the API, e.g. '9:16'
    };
  };
}

// Example numeric dimensions for each ratio.
// Adjust according to each model’s documented limits or recommendations.
const defaultDimensions = {
  [AspectRatio.NineBySixteen]: { width: 576, height: 1024, ratioParam: '9:16' },
  [AspectRatio.SixteenByNine]: { width: 1024, height: 576, ratioParam: '16:9' },
  [AspectRatio.OneByOne]: { width: 512, height: 512, ratioParam: '1:1' },
};

export const MODEL_ASPECT_RATIO_MAPPING: ModelAspectRatioMapping = {
  // Example: stable diffusion for video (if your docs say it supports these three).
  [NinjaProviderModel.StableVideoDiffusion]: {
    [AspectRatio.NineBySixteen]: defaultDimensions[AspectRatio.NineBySixteen],
    [AspectRatio.SixteenByNine]: defaultDimensions[AspectRatio.SixteenByNine],
    [AspectRatio.OneByOne]: defaultDimensions[AspectRatio.OneByOne],
  },

  // Luma Dream Machine
  [NinjaProviderModel.LumaDreamMachine]: {
    [AspectRatio.NineBySixteen]: defaultDimensions[AspectRatio.NineBySixteen],
    [AspectRatio.SixteenByNine]: defaultDimensions[AspectRatio.SixteenByNine],
    [AspectRatio.OneByOne]: {
      ...defaultDimensions[AspectRatio.OneByOne],
      ratioParam: '3:4',
    },
  },

  // Minimax Video
  [NinjaProviderModel.MinimaxVideoOneLive]: {
    [AspectRatio.NineBySixteen]: defaultDimensions[AspectRatio.NineBySixteen],
    [AspectRatio.SixteenByNine]: defaultDimensions[AspectRatio.SixteenByNine],
    [AspectRatio.OneByOne]: defaultDimensions[AspectRatio.OneByOne],
  },

  // Kling Standard
  [NinjaProviderModel.KlingStandard]: {
    [AspectRatio.NineBySixteen]: defaultDimensions[AspectRatio.NineBySixteen],
    [AspectRatio.SixteenByNine]: defaultDimensions[AspectRatio.SixteenByNine],
    [AspectRatio.OneByOne]: defaultDimensions[AspectRatio.OneByOne],
  },

  // Kling Pro
  [NinjaProviderModel.KlingPro]: {
    [AspectRatio.NineBySixteen]: defaultDimensions[AspectRatio.NineBySixteen],
    [AspectRatio.SixteenByNine]: defaultDimensions[AspectRatio.SixteenByNine],
    [AspectRatio.OneByOne]: defaultDimensions[AspectRatio.OneByOne],
  },

  // Kling 1.5
  [NinjaProviderModel.KlingOneFive]: {
    [AspectRatio.NineBySixteen]: defaultDimensions[AspectRatio.NineBySixteen],
    [AspectRatio.SixteenByNine]: defaultDimensions[AspectRatio.SixteenByNine],
    [AspectRatio.OneByOne]: defaultDimensions[AspectRatio.OneByOne],
  },

  // Runway ML
  [NinjaProviderModel.RunwayML]: {
    [AspectRatio.NineBySixteen]: defaultDimensions[AspectRatio.NineBySixteen],
    [AspectRatio.SixteenByNine]: defaultDimensions[AspectRatio.SixteenByNine],
    [AspectRatio.OneByOne]: defaultDimensions[AspectRatio.OneByOne],
  },
};
